import * as yup from 'yup';
import { eMortgageDocumentType } from '../../ui-toolkit/orders/interfaces/titleReport/eMortgageDocumentType';
import { eDeedDocumentType } from '../../ui-toolkit/orders/interfaces/titleReport/eDeedDocumentType';
import { eJudgementLienDocumentType } from '../../ui-toolkit/orders/interfaces/titleReport/eJudgementLienDocumentType';
import { isNil } from 'lodash';

// tslint:disable:object-literal-sort-keys
export const SearchReportUiValidator = (isTitleEvidenceRequired: boolean) =>
  yup.object({
    summary: yup.object({
      propertyTaxSummary: yup.string().ensure().required('Property tax summary cannot be blank'),
      titleEvidenceAgent: isTitleEvidenceRequired
        ? yup.string().nullable().required('Title Evidence Agent cannot be blank')
        : yup.string().nullable(),
      titleEvidenceFee: yup
        .number()
        .nullable()
        .when('titleEvidencePercent', (titleEvidencePercent: number | null, schema: any) => {
          return isNil(titleEvidencePercent) && isTitleEvidenceRequired
            ? schema.required('If no fee is applicable enter 0')
            : schema;
        }),
    }),

    legalAndVesting: yup.object({
      shortVested: yup.string().ensure().required('Short Vested cannot be blank'),
      legalDescription: yup.string().ensure().required('Legal description cannot be blank'),
      vested: yup.string().ensure().required('Currently vested in cannot be blank'),
    }),

    deedInformation: yup.array().of(
      yup.object({
        documentType: yup.string().ensure(),
        otherDocumentType: yup
          .string()
          .nullable(true)
          .when('documentType', {
            is: (value: eDeedDocumentType) => value === eDeedDocumentType.other,
            then: yup.string().ensure().required('Other type cannot be blank'),
          }),
      })
    ),

    mortgageInformation: yup.array().of(
      yup.object({
        documentType: yup.string().ensure(),
        otherDocumentType: yup
          .string()
          .nullable(true)
          .when('documentType', {
            is: (value: eMortgageDocumentType) => value === eMortgageDocumentType.other,
            then: yup.string().ensure().required('Other type cannot be blank'),
          }),
        documents: yup
          .array()
          .of(
            yup.object({
              mortgageDocumentType: yup.string().ensure(),
              otherMortgageDocumentType: yup
                .string()
                .nullable(true)
                .when('mortgageDocumentType', {
                  is: (value: eMortgageDocumentType) => value === eMortgageDocumentType.other,
                  then: yup.string().ensure().required('Other type cannot be blank'),
                }),
            })
          )
          .notRequired()
          .nullable(),
      })
    ),

    judgementInformation: yup.object({
      judgements: yup
        .array()
        .of(
          yup.object({
            judgementType: yup.string().ensure(),
            otherJudgementType: yup
              .string()
              .nullable(true)
              .when('judgementType', {
                is: (value: eJudgementLienDocumentType) => value === eJudgementLienDocumentType.other,
                then: yup.string().ensure().required('Other type cannot be blank'),
              }),
          })
        )
        .notRequired()
        .nullable(),
    }),
  });
